// Notifications.jsx
import React from 'react'
import PropTypes from 'prop-types'
import { injectIntl } from 'react-intl'

import styles from '../../../css/notifications.module.css'

const StatusSave = ({
  failureMessage,
  intl,
  outcome,
  successMessage,
  systemErrorMessage,
  visible,
}) => {
  if (visible) {
    const SYSTEM_ERROR_MESSAGE = intl.formatMessage({
      id: 'status.systemError',
      defaultMessage: 'Oops... Something went wrong',
      description: 'system error message - an error in the system caused a failure',
    })

    const SAVED_MESSAGE = intl.formatMessage({
      id: 'status.saved',
      defaultMessage: 'Saved',
      description: 'saved message',
    })

    const NOT_SAVED_MESSAGE = intl.formatMessage({
      id: 'status.notsaved',
      defaultMessage: 'NOT SAVED',
      description: 'not saved message',
    })

    let colorValue
    let message

    switch (outcome) {
      case 'success':
        colorValue = styles.saveStatusSuccess
        message = successMessage || SAVED_MESSAGE
        break

      case 'failure':
        colorValue = styles.saveStatusError
        message = failureMessage || NOT_SAVED_MESSAGE
        break

      default:
        colorValue = styles.saveStatusWarning
        message = systemErrorMessage || SYSTEM_ERROR_MESSAGE
        break
    }

    return (
      <div>
        <div className={`${styles.statusSavePopUp} ${colorValue}`}>
          <div className={`${styles.popUpText} ${styles.modalHead}`}>
            {message}
          </div>
        </div>
      </div>
    )
  }

  // not visible
  return ''
}

StatusSave.propTypes = {
  failureMessage: PropTypes.string,
  intl: PropTypes.object,
  outcome: PropTypes.string,
  successMessage: PropTypes.string,
  systemErrorMessage: PropTypes.string,
  timeout: PropTypes.number,
  visible: PropTypes.bool,
}

export default injectIntl(StatusSave)
